<p-dialog [(visible)]="showResetPassword" [closeOnEscape]="false" [showHeader]="false" [modal]="true" [draggable]="false" [style]="{width: '600px'}">
    <div *ngIf="!passwordIsChanged">
        <div class="partner-employees-dialog-header">Reset Password</div>
        <div class="partner-employees-dialog-description">We’ll email your employee a temporary password and use it to log in again and reset password</div>

        <div class="flex flex-row" style="margin-top: 30px">
            <button [disabled]="loading" (click)="handleHideResetPasswordDialog()" pButton type="button" class="p-button-text" label="Cancel" style="width: 137px; height: 45px; margin-right: 13px; margin-left: auto"></button>
            <button [disabled]="loading" (click)="resetPassword()" class="bluedark-btn" pButton label="Confirm" style="width: 137px; height: 45px;"></button>
        </div>
    </div>
    <div *ngIf="passwordIsChanged">
        <div class="partner-employees-dialog-header">Password has been changed</div>
        <div style="text-align:center">
            <button style="margin: 25px auto; width: 273px; height: 45px;" class="bluedark-btn" pButton label="Ok" (click)="handleHideResetPasswordDialog()"></button>
        </div>
    </div>
</p-dialog>